
    import Vue from 'vue'
    import Button from "@/components/button.vue";

    export default Vue.extend({
        name: 'pd-dtcblock',
        components: {
            "pd-button": Button
        },
        methods: {
            add() {
                this.clickFn(this.dataId)
            }
        },
        data: () => ({}),
        props: {
            clickFn: Function,
            dataObj: Object,
            dataId: String,
        }
    })
